import { autoinject } from "aurelia-framework";
import { type ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ConfigService } from "../basic/config.service";

@autoinject()
export class AppInsightsService {

    private _appInsights: ApplicationInsights;

    public async getAppInsights(): Promise<ApplicationInsights> {
        if (!this._appInsights && this.configService.config.analytics?.azureAppInsights?.instrumentationKey) {
            const module = await import('@microsoft/applicationinsights-web');
            this._appInsights = new module.ApplicationInsights({
                config: {
                    instrumentationKey: this.configService.config.analytics.azureAppInsights.instrumentationKey
                }
            });
            this._appInsights.loadAppInsights();
        }
        return this._appInsights;
    }

    constructor(private configService: ConfigService) {
    }

    async track() {
        const appInsights = await this.getAppInsights();
        if (appInsights) {
            appInsights.trackPageView(); // Manually call trackPageView to establish the current user/session/pageview
        }
    }

    async logInformation(message: string) {
        await this.logTrace(message, 1);
    }

    async logError(message: string) {
        await this.logTrace(message, 3);
    }

    private async logTrace(message: string, severityLevel: number) {
        const appInsights = await this.getAppInsights();
        if (appInsights) {
            appInsights.trackTrace({ message: message, severityLevel: severityLevel });
        }
    }
}